module.exports = __webpack_public_path__ + "img/news.94bfc7bc.jpg";